import { AdvertiseOnPageType } from 'types/publishedAssets';

export const findAdvertiseOnPageSlug = (advertiseOnPage: AdvertiseOnPageType) => {
  if (!advertiseOnPage.slugs?.length) return undefined;

  return advertiseOnPage.slugs[0].name;
};

export const determineAdvertiseOnPage = (
  idFromUrl?: (string | undefined)[],
  advertiseOnPages?: AdvertiseOnPageType[],
) => {
  if (!advertiseOnPages || advertiseOnPages.length === 0) return undefined;

  // First, check if idFromUrl matches a specific page (prioritize URL matches)
  // Iterate through idFromUrl to find the first matching page (respecting URL order)
  const advertiseOnPage = idFromUrl
    ?.filter((id): id is string => id !== undefined)
    .map((id) => advertiseOnPages?.find((page) => page.id === id || page.slugs?.[0]?.name === id))
    .find((page) => page !== undefined);

  if (advertiseOnPage) return advertiseOnPage;

  // If no URL match, fall back to home page if it exists
  const homePage = advertiseOnPages?.find((page) => page.page_type === 'home');

  if (homePage) return homePage;

  // Finally, return the first page as a last resort
  return advertiseOnPages?.[0];
};
